import { request } from '../lib/apiClient'

/** Roles with their expanded `bundles` and resolved `effective_permissions`. */
export function listRoles() {
  return request('/roles/fetch')
}
/** Profile menu → Roles. Sent WITHOUT the preview header: listing needs the
    admin's own role_preview.view, which the previewed role does not hold. */
export function listPreviewRoles() {
  return request('/roles/preview/fetch', { preview: null })
}
export function createRole(body) {
  return request('/roles/create', { method: 'POST', body })
}
export function updateRole(recordId, body) {
  return request('/roles/update', { method: 'PUT', params: { record_id: recordId }, body })
}
export function deleteRole(recordId) {
  return request('/roles/delete', { method: 'DELETE', params: { record_id: recordId } })
}

/** Permission bundles (41 seeded), each resolving to a set of tag names. */
export function listPermissions() {
  return request('/permissions/fetch')
}
export function createPermission(body) {
  return request('/permissions/create', { method: 'POST', body })
}
export function updatePermission(recordId, body) {
  return request('/permissions/update', { method: 'PUT', params: { record_id: recordId }, body })
}

/** The 104-tag catalog: 13 modules x 8 actions. */
export function listPermissionTags() {
  return request('/permission-tags/fetch')
}

/** Sets the exact tag set on one bundle. `id` comes from listPermissions(). */
export function updatePermissionTags(body) {
  return request('/roles/permission-tags/update', { method: 'PUT', body })
}

/** Access Control grid save — PUT onto a per-role overlay bundle. */
export function updateRoleMatrix(recordId, permissionTags) {
  return request('/roles/matrix/update', {
    method: 'PUT',
    params: { record_id: recordId },
    body: { permission_tags: permissionTags },
  })
}
